import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/about-team.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/trainers-cta.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/training-img.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/src/components/animation/AnimateBoxSlideDown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/sections/aw-sport-team/HeroSectionAwSportTeam.tsx");
